import { EntityRepositoryBase } from './entityRepositoryBase';

import type { EmptyJsonPub, EmptyPropsPub } from './entityBase';

/**
 * Entityの抽象クラス.
 * Repositoryを持ちAppsyncで保存する.
 */
export abstract class Entity<P, J> extends EntityRepositoryBase<P, J, EmptyPropsPub, EmptyJsonPub> {
  toJsonPub() {
    return null;
  }
}
